<template>
    <component :is="SkinComponent" v-model="form" :code="code" @save="save"></component>
</template>

<script>
import api from "@/api";

export default {
    props: {
        skin: { type: String, default: null },
        code: { type: String, default: null },
    },

    data() {
        return {
            form: {
                _work: this.$route?.query?._work,
                code: this.$props.code,

                subject: undefined,
                content: null,
                files: [],

                writer: {
                    _id: null,
                    name: null,
                    phone: null,
                    phone1: "010",
                    phone2: null,
                    phone3: null,
                    email: null,
                    email1: null,
                    email2: null,
                    email3: null,
                },

                meta: {
                    firstName: null,
                    lastName: null,
                    email: null,
                    phone: null,
                    inquiry : null,
                    message: null,
                    email1: null,
                    email2: null,
                    email3: null,
                },
            },
        };
    },

    methods: {
        validate() {
            try {
                if(!this.form.meta.firstName) throw new Error("Please enter your first name.")
                if(!this.form.meta.lastName) throw new Error("Please enter your last name.") 
                if(!this.form.meta.email1 || !this.form.meta.email2) throw new Error("Please enter your email.") 
                if(!this.form.meta.phone) throw new Error("Please enter your phone number.") 
                if(!this.form.meta.inquiry) throw new Error("Please select inquiry type.") 
                if(!this.form.meta.message) throw new Error("Please enter your message.") 

                return true;
            } catch (error) {
                this.handleError(error);
            }
            return false;
        },

        async save() {
            if (this.validate()) {
                const { files = [], ...form } = this.form;
                const { form: { _id: _form } = {} } = await api.v1.forms.post(form);

                for (const [index, file] of files.entries()) {
                    await api.v1.forms.files.post({ _form, index }, file);
                }

                alert("mail has been received");

                this.$router.go(-1);
            }
        },

        handleError(error) {
            console.error(error);
            alert(error.repsonse ? error.response.data.message : error.message);
        },
    },
    computed: {
        SkinComponent() {
            return () => import(`./skin/${this.$props.skin}/input.vue`);
        },
    },
};
</script>
